(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["birthday-gifts-listicle"] && !Shopify.designMode) return;
  try {
    
  (function(){
    /* =========================================================
       PRODUCT ORDER & DATA
       P_ORDER is the markup order (also = 30-day sales rank).
       AGE_FIT_RAW: rows = ages, columns = products in P_ORDER.
       Values are age-fit scores (0 = no fit, 4 = perfect fit).
       SALES_RANK: 30-day gross sales rank (1 = best seller).
       Last refreshed: 2026-05-12
       ========================================================= */
    var P_ORDER = [
      'busyboard','whale','nailtrimmer','toothbrush','spinner','cube',
      'rattlesocks','tummymat','octopus','colorbook','eggs','snackcups',
      'books','projector','magnetic','farmset'
    ];

    var AGE_FIT_RAW = {
      /*           bb wh nt tb sp cu rs tm oc cb eg sc bk pr mg fs */
      under1:    [ 0, 3, 4, 0, 0, 3, 4, 4, 3, 0, 0, 3, 4, 0, 0, 0 ],
      '1':       [ 3, 4, 0, 2, 3, 3, 0, 0, 3, 0, 4, 4, 2, 0, 0, 0 ],
      '2':       [ 4, 4, 0, 3, 4, 4, 0, 0, 4, 0, 4, 4, 0, 0, 0, 0 ],
      '3':       [ 4, 3, 0, 4, 3, 2, 0, 0, 3, 4, 4, 3, 0, 4, 4, 4 ],
      '4':       [ 4, 2, 0, 4, 2, 2, 0, 0, 2, 4, 4, 2, 0, 4, 4, 4 ]
    };

    var AGE_FIT = {};
    Object.keys(AGE_FIT_RAW).forEach(function(age){
      AGE_FIT[age] = {};
      P_ORDER.forEach(function(k, i){ AGE_FIT[age][k] = AGE_FIT_RAW[age][i]; });
    });

    var SALES_RANK = {
      busyboard:1, whale:2, nailtrimmer:3, toothbrush:4, spinner:5,
      cube:6, rattlesocks:7, tummymat:8, octopus:9, colorbook:10,
      eggs:11, snackcups:12, books:13, projector:14, magnetic:15, farmset:16
    };

    var TOP_N = 8;
    var selected = {};
    var ALL_AGES = ['under1','1','2','3','4'];
    var activeAges = []; // start empty; empty === "show all" (sorts by sales rank)
    var sections = Array.prototype.slice.call(document.querySelectorAll('.product[data-key]'));

    function scoreProduct(key){
      var total = 0;
      activeAges.forEach(function(age){
        total += (AGE_FIT[age] && AGE_FIT[age][key]) || 0;
      });
      return total;
    }

    function applyFilter(){
      // Empty activeAges === "Show all" === sort purely by 30-day sales rank.
      // Any pills selected === filtered view, sort by age-fit score with sales tiebreak.
      var showAll = activeAges.length === 0;
      var scored = sections.map(function(sec){
        var key = sec.getAttribute('data-key');
        return { sec: sec, key: key, score: scoreProduct(key), rank: SALES_RANK[key] || 99 };
      });
      if (showAll) {
        scored.sort(function(a, b){ return a.rank - b.rank; });
      } else {
        // Filtered view: drop zero-fit products, then sort by age-fit score, tiebreak by sales rank
        scored = scored.filter(function(item){ return item.score > 0; });
        scored.sort(function(a, b){
          if (b.score !== a.score) return b.score - a.score;
          return a.rank - b.rank;
        });
      }
      var visible = scored.slice(0, TOP_N);
      var hidden = scored.slice(TOP_N);
      var allKeys = P_ORDER.slice();
      var visibleKeys = visible.map(function(i){ return i.key; });
      var hiddenAll = allKeys.filter(function(k){ return visibleKeys.indexOf(k) === -1; });

      var main = document.querySelector('main.page');
      visible.forEach(function(item, idx){
        item.sec.classList.remove('is-filtered-out');
        var rankEl = item.sec.querySelector('[data-tq-rank]');
        if (rankEl) rankEl.textContent = (idx + 1);
        main.appendChild(item.sec);
      });
      hiddenAll.forEach(function(k){
        var sec = document.querySelector('.product[data-key="' + k + '"]');
        if (sec) sec.classList.add('is-filtered-out');
      });
      var finalNote = document.querySelector('.final-note');
      if (finalNote && main) main.appendChild(finalNote);
    }

    var resetPill = document.querySelector('[data-age-reset]');

    function syncResetPill(){
      // Reset pill is "active" when no age pills are selected (the "Show all" state).
      if (resetPill) {
        resetPill.classList.toggle('is-active', activeAges.length === 0);
      }
    }

    var pills = document.querySelectorAll('.age-pill[data-age]');
    pills.forEach(function(pill){
      pill.addEventListener('click', function(){
        var age = pill.getAttribute('data-age');
        var isActive = pill.classList.contains('is-active');
        if (isActive) {
          pill.classList.remove('is-active');
          activeAges = activeAges.filter(function(a){ return a !== age; });
        } else {
          pill.classList.add('is-active');
          activeAges.push(age);
        }
        syncResetPill();
        applyFilter();
      });
    });

    if (resetPill) {
      resetPill.addEventListener('click', function(){
        // If already in "Show all" state (no pills active), do nothing
        if (activeAges.length === 0) return;
        activeAges = [];
        pills.forEach(function(p){ p.classList.remove('is-active'); });
        syncResetPill();
        applyFilter();
      });
    }

    syncResetPill();

    sections.forEach(function(sec){
      var btn = sec.querySelector('[data-tq-add]');
      if (!btn) return;
      var key = sec.getAttribute('data-key');
      btn.addEventListener('click', function(){
        selected[key] = !selected[key];
        sec.classList.toggle('is-selected', !!selected[key]);
        btn.classList.toggle('is-added', !!selected[key]);
        var labelEl = btn.querySelector('[data-cta-label]');
        if (labelEl) {
          labelEl.textContent = selected[key] ? '\u2713 Added to Bundle' : '+ Add to Bundle';
        }
        if (selected[key]) forceBundleReveal();
        updateBundleBar();
      });
    });

    var CURRENCY_SYMBOL = '$';
    try {
      var code = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      var cookieMatch = document.cookie.match(/(?:^|;\s*)cart_currency=([^;]+)/);
      if (cookieMatch && cookieMatch[1]) code = cookieMatch[1];
      var symbolMap = {
        USD:'$', AUD:'A$', CAD:'C$', NZD:'NZ$', GBP:'\u00a3', EUR:'\u20ac',
        JPY:'\u00a5', SGD:'S$', CHF:'CHF ', SEK:'kr', NOK:'kr', DKK:'kr',
        ISK:'kr', PLN:'z\u0142', MYR:'RM ', PHP:'\u20b1'
      };
      CURRENCY_SYMBOL = symbolMap[code] || (code + ' ');
    } catch(e){}

    function money(cents){
      return CURRENCY_SYMBOL + (cents/100).toFixed(2);
    }

    function updateBundleBar(){
      var keys = Object.keys(selected).filter(function(k){ return selected[k]; });
      var count = keys.length;
      var total = 0;
      keys.forEach(function(k){
        var sec = document.querySelector('.product[data-key="' + k + '"]');
        if (sec) total += parseInt(sec.getAttribute('data-price'), 10) || 0;
      });
      document.querySelector('[data-tq-count]').textContent = count;
      var totalEl = document.querySelector('[data-tq-total]');
      if (count === 0) {
        totalEl.textContent = 'Pick at least one';
        totalEl.classList.add('is-empty');
      } else {
        totalEl.textContent = money(total);
        totalEl.classList.remove('is-empty');
      }
      var btn = document.querySelector('[data-tq-checkout]');
      btn.disabled = count === 0;
      btn.textContent = count <= 1 ? 'Add to Cart \u2192' : 'Add ' + count + ' to Cart \u2192';
      try {
        window.dispatchEvent(new Event('bucks:convert'));
        document.dispatchEvent(new Event('currency:converted'));
      } catch(e){}
    }

    document.querySelector('[data-tq-checkout]').addEventListener('click', function(){
      var keys = Object.keys(selected).filter(function(k){ return selected[k]; });
      if (!keys.length) return;
      var btn = this;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding\u2026';
      var items = keys.map(function(k){
        var sec = document.querySelector('.product[data-key="' + k + '"]');
        return { id: parseInt(sec.getAttribute('data-variant'), 10), quantity: 1 };
      });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: items })
      })
      .then(function(r){ if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){
        openUpCartDrawer();
        try {
          if (window.fbq) window.fbq('track', 'AddToCart', {
            content_ids: keys, content_type: 'product', num_items: keys.length
          });
        } catch(e){}
        setTimeout(function(){
          btn.disabled = false;
          btn.textContent = originalText;
          keys.forEach(function(k){
            selected[k] = false;
            var sec = document.querySelector('.product[data-key="' + k + '"]');
            if (sec) sec.classList.remove('is-selected');
            var b = sec && sec.querySelector('[data-tq-add]');
            if (b) {
              b.classList.remove('is-added');
              var lbl = b.querySelector('[data-cta-label]');
              if (lbl) lbl.textContent = '+ Add to Bundle';
            }
          });
          updateBundleBar();
        }, 1200);
      })
      .catch(function(err){
        console.error('[Listicle] Cart add failed:', err);
        btn.disabled = false;
        btn.textContent = originalText;
        alert('Something went wrong. Please try again.');
      });
    });

    function openUpCartDrawer(){
      try {
        if (typeof window.UpCart === 'object' && window.UpCart) {
          if (typeof window.UpCart.openCart === 'function') { window.UpCart.openCart(); return; }
          if (typeof window.UpCart.open === 'function')     { window.UpCart.open();     return; }
        }
        if (typeof window.openUpCart === 'function') { window.openUpCart(); return; }
      } catch(e){}
      try {
        if (typeof window.AfterSell === 'object' && window.AfterSell && window.AfterSell.UpCart) {
          if (typeof window.AfterSell.UpCart.open === 'function') { window.AfterSell.UpCart.open(); return; }
        }
      } catch(e){}
      try {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { openMiniCart: true, openCart: true } }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      } catch(e){}
      var triggers = ['#upcart-cart-trigger', '.upcart-cart-trigger', '[data-upcart-trigger]', 'a[href="/cart"]'];
      for (var i = 0; i < triggers.length; i++) {
        var el = document.querySelector(triggers[i]);
        if (el) { try { el.click(); return; } catch(e){} }
      }
    }

    var dock = document.querySelector('[data-tq-dock]');
    var firstProduct = document.querySelector('.product[data-key]');
    var bundleRevealed = false;

    function checkBundleReveal(){
      if (bundleRevealed || !firstProduct || !dock) return;
      var rect = firstProduct.getBoundingClientRect();
      if (rect.bottom < window.innerHeight * 0.85) {
        dock.classList.add('is-bundle-visible');
        document.body.classList.add('has-bundle-row');
        bundleRevealed = true;
        window.removeEventListener('scroll', checkBundleReveal);
      }
    }

    window.addEventListener('scroll', checkBundleReveal, { passive: true });

    function forceBundleReveal(){
      if (bundleRevealed) return;
      dock.classList.add('is-bundle-visible');
      document.body.classList.add('has-bundle-row');
      bundleRevealed = true;
      window.removeEventListener('scroll', checkBundleReveal);
    }

    applyFilter();
    updateBundleBar();

    /* =========================================================
       CAROUSEL — independent state per product
       ========================================================= */
    Array.prototype.slice.call(document.querySelectorAll('[data-carousel]')).forEach(function(car){
      var slides = Array.prototype.slice.call(car.querySelectorAll('.carousel-slide'));
      var dots   = Array.prototype.slice.call(car.querySelectorAll('.carousel-dot'));
      var prev   = car.querySelector('[data-prev]');
      var next   = car.querySelector('[data-next]');
      if (slides.length <= 1) return;
      var idx = 0;

      function goTo(i){
        idx = (i + slides.length) % slides.length;
        slides.forEach(function(s, k){ s.classList.toggle('is-active', k === idx); });
        dots.forEach(function(d, k){ d.classList.toggle('is-active', k === idx); });
      }

      if (prev) prev.addEventListener('click', function(e){ e.stopPropagation(); goTo(idx - 1); });
      if (next) next.addEventListener('click', function(e){ e.stopPropagation(); goTo(idx + 1); });
      dots.forEach(function(d, k){
        d.addEventListener('click', function(e){ e.stopPropagation(); goTo(k); });
      });

      // Touch swipe
      var startX = 0, startY = 0, dx = 0, dy = 0, swiping = false;
      car.addEventListener('touchstart', function(e){
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        dx = 0; dy = 0; swiping = true;
      }, { passive: true });
      car.addEventListener('touchmove', function(e){
        if (!swiping) return;
        dx = e.touches[0].clientX - startX;
        dy = e.touches[0].clientY - startY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
          // allow horizontal swipe
        } else if (Math.abs(dy) > Math.abs(dx)) {
          swiping = false;
        }
      }, { passive: true });
      car.addEventListener('touchend', function(){
        if (swiping && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          goTo(idx + (dx < 0 ? 1 : -1));
        }
        swiping = false;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
